import React from "react";
import "../ModalEditWindow.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import CallBackComponent from "./../../CallBack";

class CallBack extends React.Component {
  render() {
    return (
      <>
        <CallBackComponent />
      </>
    );
  }
}

const withForm = connect(
  (state) => ({}),
  (dispatch) => bindActionCreators({}, dispatch)
);

export default withTranslation()(withForm(CallBack));
